import React from "react";

const SubContact = _ => (
    <div style={styles.subContactContainer}>
        <div style={styles.subContactSocialIcons}>
            <a href="https://www.facebook.com/ahsanusman26" style={styles.socialIcons} rel="noopener noreferrer" target="_blank">
                <i className="fab fa-facebook-f"></i>
            </a>
            <a style={styles.socialIcons}>
                <i class="fab fa-whatsapp-square"></i>/<span style={styles.whatAppNum}>03012793707</span>
            </a>
            <a href="https://join.skype.com/invite/LkIgrkCY3ZgT" style={styles.socialIcons} rel="noopener noreferrer" target="_blank">
                <i class="fab fa-skype"></i>
            </a>
            <a href="https://twitter.com/ahsanusman26" style={styles.socialIcons} rel="noopener noreferrer" target="_blank">
                <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.instagram.com/ahsanusman1/" style={styles.socialIcons} rel="noopener noreferrer" target="_blank">
                <i class="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCZNYHkeUsnwGz6BFS6QUzkA" style={styles.socialIcons} rel="noopener noreferrer" target="_blank">
                <i class="fab fa-youtube"></i>
            </a>
            <a href="https://www.github.com/ahsan26" style={styles.socialIcons} rel="noopener noreferrer" target="_blank">
                <i className="fab fa-github"></i>
            </a>
        </div>
        <p style={styles.footerNote}>Handmade by me © 2018.</p>
    </div>
);

const styles = {
    subContactContainer: {
        backgroundColor: "#232323",
        height: 150,
        paddingTop: 50
    },
    subContactSocialIcons: {
        textAlign: "center",
        fontSize: 20
    },
    socialIcons: {
        color: "#C80A48",
        marginRight: 15
    },
    footerNote: {
        color: "#fff",
        textAlign: "center",
        marginTop: 20
    },
    whatAppNum: {
        cursor: 'pointer'
    }
};

export default SubContact;


// WEBPACK FOOTER //
// ./src/Components/subContact.jsx